var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMic = function SvgMic(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-label": "Microphone icon",
    width: 22,
    viewBox: "0 0 25 41",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.344 36.01c3.483-3.76 11.325-6.376 11.297-14.2M12.39 36.019C8.888 32.287 1.028 29.716 1 21.902M3.912 40l16.937-.055M12.371 36.083l.01 3.889",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.458 18.032c0-1.382 5.63-4.257 5.63-5.658-.009-1.4-5.639 1.456-5.648.056-.01-1.401 5.63-4.258 5.63-5.658-.01-2.912-1.843-5.585-4.626-6.442-4.672-1.437-8.938 2.018-8.92 6.46l.01 2.921c.009 1.4 5.639-1.456 5.648-.055.01 1.4-5.63 4.257-5.63 5.658.01 1.4 5.64-1.456 5.649-.056.009 1.401-5.63 4.258-5.63 5.658.009 2.912 1.842 5.585 4.625 6.442 4.663 1.437 8.93-2.018 8.92-6.47l-.009-2.755c-.01-2.183-5.649 1.281-5.649-.1z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMic, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mic.b663dc7c.svg";
export { ForwardRef as ReactComponent };